module.exports = __webpack_public_path__ + "img/about-grid-05.281a9aed.jpg";